module.exports = __webpack_public_path__ + "static/exam-486-developing-asp-net-mvc-web-applications-7500c8e94eb357e42fe7e66e5a78a6f1.png";